<template>
  <div class="app">
    <div v-if="status == 1" class="app-status">
      <div class="app-status-icon-loading"></div>
      <div class="app-status-txt1">连接中</div>
    </div>

    <div v-if="status == 2" class="app-status">
      <div class="app-status-icon-loading"></div>
      <div class="app-status-txt1">等待初始化</div>
    </div>
    <router-view v-else-if="status == 3" />
    <div v-else-if="status == 4" class="app-status">
      <div class="app-status-icon-err"></div>
      <div class="app-status-txt2">连接失败,重试中</div>
    </div>

    <div class="app-loading" v-if="appLoading">
      <img :src="require('./assets/myloading.png')" />
      <p>Loading...</p>
    </div>
  </div>
</template>
<script>
import {
  setRoot,
  msgArr,
  setSocketObj,
  socketObj,
  addBro,
  removeBro,
  sendOnly,
} from "./socket/index.js";
import { mapMutations } from "vuex";
import { setRoot as setRoot2 } from "./util/request.js";
import { url } from "./config/index.js";
import { setAppRoot } from "./store";
export default {
  name: "App",
  data() {
    return {
      status: 0,
      initBroObj: {
        callbackName: "getInitBro",
        callbackF: this.initBroCallbackF,
      },
      initBroObjOne: {
        callbackName: "getInitSingleBro",
        callbackF: this.initBroCallbackFOne,
      },
      initBroObjNet: {
        callbackName: "getNetworkStatusBro",
        callbackF: this.initBroCallbackFNet,
      },
      appLoading: false,
    };
  },
  components: {},
  methods: {
    ...mapMutations["setTick"],
    openLoadng() {
      this.appLoading = true;
    },
    closeLoading() {
      this.appLoading = false;
    },
    initBroCallbackFNet(res) {
      this.$store.commit("initNetSatus", res.data.netReachable);
    },
    initBroCallbackF(res) {
      // console.log("initBroCallbackF");
      // console.log(res);
      this.status = 3;
      this.$store.commit("init", res.data);
    },

    initBroCallbackFOne(res) {
      console.log("initBroCallbackFOne");
      // console.log("initBroCallbackF");
      // console.log(res);
      // this.status = 3;
      this.$store.commit("initOne", res.data);
    },

    init() {
      // 全量disk
      addBro(this.initBroObj);
      // 单个disk
      addBro(this.initBroObjOne);

      addBro(this.initBroObjNet);
      sendOnly({
        name: "getInitReq",
      });
      // sendOnly({
      //   name: "getNetworkStatusReq",
      // });
    },
    reload() {
      this.status = 1;
      // setSocketObj(new WebSocket("ws://127.0.0.1:8881/websocket/che"));
      // setSocketObj(new WebSocket("ws://192.168.1.10:8881/websocket/che"));
      // setSocketObj(new WebSocket("ws://47.104.189.19:8881/websocket/che"));
      // setSocketObj(new WebSocket("ws://localhost:9999/websocket/che"));
      if (process.env.NODE_ENV == "development") {
        setSocketObj(new WebSocket(url));
      } else {
        const socketUrl =
          "ws://" +
          window.location.hostname +
          ":" +
          (Number(window.location.port) + 1) +
          "/websocket/che";
        setSocketObj(new WebSocket(socketUrl));
      }

      socketObj.onopen = async () => {
        console.log(" socket open");
        this.status = 2;
        await this.init();
        // await this.initStatus();
      };

      socketObj.onmessage = (e) => {
        // console.log(e.data);
        console.log("=============================");

        console.log(" socket msg");
        let dataObj = JSON.parse(e.data);
        // console.log(dataObj);
        console.log("=============================");
        // console.log(msgArr, "msgArrmsgArrmsgArr");

        msgArr.forEach((v, k) => {
          if (v.callbackName == dataObj.name) {
            v.callbackF(dataObj);
          }
        });
      };

      socketObj.onerror = () => {
        console.log(" socket err");
      };
      socketObj.onclose = () => {
        console.log(" socket close");
        this.status = 4;
        this.$router.push({ name: "Index" });
        setTimeout(() => {
          this.reload();
        }, 2000);
      };
    },
    async initStatus() {
      try {
        let res = await this.$myRequest({
          url: "/get-init-status",
          method: "get",
          data: {},
        });
        res = res.data;
        if (res.data.status == 0) {
          this.$router.push({ name: "DeviceSet" });
        }
      } catch (err) {
        console.log("err  init");
        console.log(err);
      }
    },
  },
  async mounted() {
    // console.log("app mounted");
    // console.log(this);
    // console.log(this.$router);
    // console.log(this.$route);
    const _this = this;
    setRoot(this);
    setRoot2(this);
    setAppRoot(this);
    await this.initStatus();

    this.reload();

    const list = [
      "adminSetIndex",
      "adminAutoSet",
      "adminSetParam",
      "adminSetDeviceHome",
      "adminSetSystemHome",
      "DiffSet",
    ];

    document.body.addEventListener("click", function (e) {
      if (list.some((i) => i == _this.$route.name)) {
        console.log("----@@@@@@@-----");
        if (_this.$store) {
          _this.$store.commit("setTick");
        }
      }
    });
  },
  beforeUnmount() {
    removeBro(this.initBroObj);
  },
};
</script>
<style lang="less" src="./app/reset.less"></style>
<style lang="less" src="./app/common.less"></style>
<style scoped lang="less" src="./app/index.less"></style>
